import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../shared/constants';
import { HeaderFilterOption, LoadOptions } from '../shared/models/shared.model';
import { Observable } from 'rxjs';
import {
  CountrySubdivisionMasterWithReportRegionListGridResultModel,
  CountrySubdivisionMappingGridModel, CountrySubdivisionMappingGridResultModel
} from '../shared/models/country-subdivision-data.model';
import { HeaderFilterData } from '../shared/models/product.model';

@Injectable({
  providedIn: 'root'
})

export class CountrySubdivisionDataService {
  private token = localStorage.getItem('token');
  private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

  private url = Constants.devServerEndpoint + 'api/countrysubdivisiondata';

  constructor(private httpClient: HttpClient) { }

  public getCountrySubdivisionMasterWithReportRegionListGrid(param: LoadOptions):
	Observable<CountrySubdivisionMasterWithReportRegionListGridResultModel> {
	return this.httpClient
		.post<CountrySubdivisionMasterWithReportRegionListGridResultModel>(
		this.url + `/getCountrySubdivisionMasterWithReportRegionListGrid/`, param,
		{ headers: this.headers }
		);
  }

  public getHeaderFiltersCountrySubdivisionMasterWithReportRegionListGrid(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
	return this.httpClient
		.post<HeaderFilterData[]>(
		this.url + `/getHeaderFiltersCountrySubdivisionMasterWithReportRegionListGrid`, param,
		{ headers: this.headers }
		);
  }

  public getCountrySubdivisionMappingGrid(param: LoadOptions):
	Observable<CountrySubdivisionMappingGridResultModel> {
	return this.httpClient
		.post<CountrySubdivisionMappingGridResultModel>(
		this.url + `/getCountrySubdivisionMappingGrid/`, param,
		{ headers: this.headers }
		);
  }

  public getHeaderFiltersCountrySubdivisionMappingGrid(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
	return this.httpClient
		.post<HeaderFilterData[]>(
		this.url + `/getHeaderFiltersCountrySubdivisionMappingGrid`, param,
		{ headers: this.headers }
		);
  }

  public mappingAction(param): Observable<any> {
	return this.httpClient
		.post<any>(
		this.url + '/mappingAction', param,
		{ headers: this.headers }
		);
  }
}
